import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export function RPCClick(el) {
	if (null==el) return;
	console.log("el = ", el);
	let click = function(evt) {
		// Find the data-rpc containing parent
		let el = evt.target;
		while ((null!=el) && (!el.hasAttribute('data-rpc'))) {
			el = el.parentNode;
		}
		if (null==el) {
			// No parent node found, which shouldn't happen...
			console.error(`NO PARENT NODE found looking for data-rpc`);
			return false;
		}
		evt.stopPropagation();
		evt.preventDefault();

		console.log(`JSON = X${el.getAttribute('data-rpc')}X`);
		let js = JSON.parse(el.getAttribute('data-rpc'));

		console.log("GOT json info ", js);
		let gotoF = (function(url) {
			return function() {
				if ('undefined'!=typeof url) {
					document.location = url;
				}
			}
		})(js.url);
		// Will throw syntax error on failure
		if ("undefined" != typeof js.confirm) {
			if (!confirm(js.confirm)) return true;
		}
		if ("undefined" == typeof js.method) {
			document.location = js.url;
			return true;
		}
		let rpc = DojoDeshi.instance().RPC();
		console.log(`rpc = `, rpc, ` and js.method = `, js.method);
		// let f = rpc[js.method];
		rpc[js.method](...js.params).then(
			function(res) {
				gotoF();
			},
			function(err) {
				console.error(`ERROR on RPC ${js.method}: `, err);
				alert(`ERROR on RPC ${js.method}`);
			}
		);
	}
	if (el.hasAttribute('data-rpc')) {
		el.addEventListener('click', click);
	}
	for (let e of el.querySelectorAll('[data-rpc]')) {
		console.log("Binding RPC to ", e);
		e.addEventListener('click', click);
	}
}

window.RPCClick = RPCClick;